import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ApiResponse } from '../models/api-response/api-response.model';
import { PaginatedResponse } from '../models/paginations/paginated-response.model';
import { PaginationService } from './pagination.service';
import { ExpenseForCreation } from '../models/expenses/expense-for-creation.model';
import { ExpenseForListing } from '../models/expenses/expense-for-listing.model';
import { ExpenseForUpdation } from '../models/expenses/expense-for-updation.model';
import { ExpenseRequestFilter } from '../models/expenses/expense-request-filter.model';
import { ExpenseDto } from '../models/expenses/expense.model';

@Injectable({
  providedIn: 'root'
})
export class ExpenseService {
  private apiUrl = `${environment.apiUrl}/expenses`;

  constructor(private http: HttpClient, private paginationService: PaginationService) { }

  getPaginatedExpenses(filter: ExpenseRequestFilter): Observable<PaginatedResponse<ExpenseForListing>> {
    return this.paginationService.getPaginatedData<ExpenseForListing>(this.apiUrl, filter);
  }

  getExpenseById(id: number): Observable<ExpenseDto> {
    return this.http.get<ExpenseDto>(`${this.apiUrl}/${id}`);
  }

  createExpense(data: ExpenseForCreation): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.apiUrl, data);
  }

  updateExpense(data: ExpenseForUpdation): Observable<ApiResponse> {
    return this.http.put<ApiResponse>(this.apiUrl, data);
  }

  softDeleteExpense(id: number): Observable<ApiResponse> {
    return this.http.delete<ApiResponse>(`${this.apiUrl}/soft/${id}`);
  }
}
